import Fancybox from './Fancybox';

export default Fancybox;
